import React from "react";

/**
 * Scrollable row of company tags
 *
 * Props (optional):
 *   data – array of { name, code } objects
 */
 function CompanyTagRowsUI({
  companies = [],
}) {
  return (
    <div className="w-full overflow-x-auto">
      {/* Hide default scrollbar in WebKit browsers */}
      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
      `}</style>

      <div className="hide-scrollbar flex w-max space-x-2 py-2">
        {companies.map((company) => (
          <CompanyTagTealLargeUI company={company} />
        ))}
      </div>
    </div>
  );
}

/** needs name and code filled inside company */
function CompanyTagUI({company}){
    return (
         <span
            key={company.code}
            className=" rounded-full basis-1/4
             bg-slate-200 hover:bg-slate-300
              px-1  py-1 text-sm font-medium text-slate-700"
          >
            <a
            key={company.code}
            href={`/dsa/${company.code}`}
            className=" rounded-full
              px-1 py-1 text-sm font-medium
              text-slate-700 hover:text-slate-900 hover:underline transition"
          >
            {company.name}
            </a>
          </span>
    );
}

/** needs name and code filled inside company */
function CompanyTagTealUI({company}){
    return (
    <span
        key={company.code}
        className="px-2 py-2 rounded-full bg-teal-500
        
         text-white text-center text-sm basis-1/4"
        >
        <a
    href={`/dsa/${company.code}`}
    className=" px-1 py-1 text-white  hover:underline"
    >
    {company.name}
    </a>
        
        </span>
    );
}

/** needs name and code filled inside company */
function CompanyTagTealLargeUI({company}){
    return (
    <span
        key={company.code}
        className="px-2 py-2 rounded-full bg-teal-500
        hover:bg-teal-600
         text-white text-center text-sm items-center justify-center "
        >
        <a
    href={`/dsa/${company.code}`}
    className=" px-3 py-2 text-white  hover:underline"
    >
    {company.name}
    </a>
        
        </span>
    );
}
export {CompanyTagUI, CompanyTagTealUI, 
    CompanyTagTealLargeUI, CompanyTagRowsUI}